import type { FetchResult } from '@apollo/client';

import {
  useGetAllGroupsQuery,
  useSendGroupEmailInviteMutation,
  useUpdateGroupMutation,
} from 'generated/group.generated';
import type {
  SendGroupEmailInviteMutation,
  SendGroupEmailInviteMutationVariables,
  UpdateGroupMutation,
  UpdateGroupMutationVariables,
} from 'generated/group.generated';

export const useGetUserGroups = () => {
  const response = useGetAllGroupsQuery();
  return { ...response, data: response.data?.getAllGroups };
};

export function useUpdateGroup(): [
  (
    params: UpdateGroupMutationVariables
  ) => Promise<FetchResult<UpdateGroupMutation>>,
  boolean,
] {
  const [mutate, { loading: baseLoading }] = useUpdateGroupMutation();
  const loading = baseLoading;

  async function updateGroup(params: UpdateGroupMutationVariables) {
    const response = await mutate({
      variables: { ...params },
    });
    return response;
  }
  return [updateGroup, loading];
}

export function useSendGroupInvite(): [
  (
    params: SendGroupEmailInviteMutationVariables
  ) => Promise<FetchResult<SendGroupEmailInviteMutation>>,
  boolean,
] {
  const [mutate, { loading: baseLoading }] = useSendGroupEmailInviteMutation();
  const loading = baseLoading;

  async function sendEmailInvite(
    params: SendGroupEmailInviteMutationVariables
  ) {
    const response = await mutate({
      variables: { ...params },
    });
    return response;
  }
  return [sendEmailInvite, loading];
}
